/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartBarsAUpIcon24Regular = forwardRef('DataChartBarsAUpIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M19.75 5a.75.75 0 0 0-1.5 0v15a.75.75 0 0 0 1.5 0V5Z" }),
        React.createElement("path", { d: "M14 7.75a.75.75 0 0 1 .75.75V20a.75.75 0 0 1-1.5 0V8.5a.75.75 0 0 1 .75-.75Z" }),
        React.createElement("path", { d: "M9.75 12a.75.75 0 0 0-1.5 0v8a.75.75 0 0 0 1.5 0v-8Z" }),
        React.createElement("path", { d: "M4.75 15.5a.75.75 0 0 0-1.5 0V20a.75.75 0 0 0 1.5 0v-4.5Z" })));
});
